/**
 * @generated SignedSource<<c01c5a4c02bd293b4ac80725a6cf47e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSoldItemLinksPdpClientVariant_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly " $fragmentType": "useSoldItemLinksPdpClientVariant_item";
};
export type useSoldItemLinksPdpClientVariant_item$key = {
  readonly " $data"?: useSoldItemLinksPdpClientVariant_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSoldItemLinksPdpClientVariant_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSoldItemLinksPdpClientVariant_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6953dd48aafa9b7ac0ce6f626c69ad7a";

export default node;
